/* This is generated code, don't alter */
var IfcCableCarrierSegmentTypeEnum;
(function (IfcCableCarrierSegmentTypeEnum) {
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["CABLELADDERSEGMENT"] = 0] = "CABLELADDERSEGMENT";
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["CABLETRAYSEGMENT"] = 1] = "CABLETRAYSEGMENT";
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["CABLETRUNKINGSEGMENT"] = 2] = "CABLETRUNKINGSEGMENT";
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["CONDUITSEGMENT"] = 3] = "CONDUITSEGMENT";
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["USERDEFINED"] = 4] = "USERDEFINED";
    IfcCableCarrierSegmentTypeEnum[IfcCableCarrierSegmentTypeEnum["NOTDEFINED"] = 5] = "NOTDEFINED";
})(IfcCableCarrierSegmentTypeEnum || (IfcCableCarrierSegmentTypeEnum = {}));
const IfcCableCarrierSegmentTypeEnumCount = 6;
export { IfcCableCarrierSegmentTypeEnum, IfcCableCarrierSegmentTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcCableCarrierSegmentTypeEnum = new Int32Array([12]);
let prefixSumAddressIfcCableCarrierSegmentTypeEnum = new Uint32Array([0, 13, 29, 49, 67, 89, 101]);
let slotMapIfcCableCarrierSegmentTypeEnum = new Int32Array([4, 3, 0, 1, 2, 5]);
let encodedDataIfcCableCarrierSegmentTypeEnum = (new TextEncoder()).encode(".USERDEFINED..CONDUITSEGMENT..CABLELADDERSEGMENT..CABLETRAYSEGMENT..CABLETRUNKINGSEGMENT..NOTDEFINED.");
let IfcCableCarrierSegmentTypeEnumSearch = new MinimalPerfectHash(gMapIfcCableCarrierSegmentTypeEnum, prefixSumAddressIfcCableCarrierSegmentTypeEnum, slotMapIfcCableCarrierSegmentTypeEnum, encodedDataIfcCableCarrierSegmentTypeEnum);
export { IfcCableCarrierSegmentTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcCableCarrierSegmentTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcCableCarrierSegmentTypeEnumSearch, input, cursor, endCursor);
}
